enum ROUTES {
  TRANSACTIONS = '/transactions',
  GENERAL_LEDGER = '/transactions/general-ledger',
  GENERAL_LEDGER_CREATE = '/transactions/general-ledger/create',
  GENERAL_LEDGER_READ = '/transactions/general-ledger/:transactionId',
  GENERAL_LEDGER_FEE = '/transactions/general-ledger/service-fee/:transactionId',
  GENERAL_LEDGER_FEE_GENERAL = '/transactions/general-ledger/service-fee/:transactionId/general',
  GENERAL_LEDGER_FEE_LOG = '/transactions/general-ledger/service-fee/:transactionId/log',
  GENERAL_LEDGER_FEE_WARNING = '/transactions/general-ledger/service-fee/:transactionId/warning',
  GENERAL_LEDGER_FEE_CHANGE_LOG = '/transactions/general-ledger/service-fee/:transactionId/change-log',
  INTERNAL_TRANSACTION = '/transactions/internal',
  INTERNAL_TRANSACTION_CREATE = '/transactions/internal/create',
  INTERNAL_TRANSACTION_READ = '/transactions/internal/:transactionId',
  INTERNAL_TRANSACTION_GL = '/transactions/internal/general-ledged/:glId',
  INCOMING = '/transactions/incoming',
  INCOMING_TRANSACTION = '/transactions/incoming/:transactionId',
  INCOMING_TRANSACTION_GL = '/transactions/incoming/general-ledged/:glId',
  INCOMING_TRANSACTION_CREATE = '/transactions/incoming/create',
  OUTGOING = '/transactions/outgoing',
  OUTGOING_TRANSACTION = '/transactions/outgoing/:transactionId',
  OUTGOING_TRANSACTION_GL = '/transactions/outgoing/general-ledged/:glId',
  OUTGOING_TRANSACTION_CREATE = '/transactions/outgoing/create',
  EXPORT = '/transactions/export',
  EXPORT_BANKS = '/transactions/export/:bankId',
  EXPORT_ACCOUNTS = '/transactions/export/:bankId/:accountId',
  EXPORT_BATCHES = '/transactions/export/:bankId/:accountId/batches',
  EXPORT_BATCHES_ADD = '/transactions/export/:bankId/:accountId/batches/add',
  EXPORT_BATCHES_ADD_OUTGOING = '/transactions/export/:bankId/:accountId/batches/add/outgoing/:transactionId',
  EXPORT_BATCHES_READ = '/transactions/export/:bankId/:accountId/batches/:batchId',
  EXPORT_BATCHES_READ_OUTGOING = '/transactions/export/:bankId/:accountId/batches/:batchId/outgoing/:transactionId',
  NOSTRO_TRANSFERS = '/transactions/nostro',
  NOSTRO_TRANSFER = '/transactions/nostro/:transactionId',
  NOSTRO_TRANSACTION_GL = '/transactions/nostro/general-ledged/:glId',
  NOSTRO_TRANSFER_CREATE = '/transactions/nostro/create',
  IMPORT = '/transactions/import',
  IMPORT_ITEM = '/transactions/import/:transactionId',
  EXCHANGE = '/transactions/exchange',
  EXCHANGE_GL = '/transactions/exchange/general-ledged/:glId',
  EXCHANGE_READ = '/transactions/exchange/:transactionId',
  EXCHANGE_CREATE = '/transactions/exchange/create',
  CASH_COLLECTION = '/transactions/cash-collection',
  CASH_COLLECTION_LIST = '/transactions/cash-collection/list',
  CASH_COLLECTION_CREATE = '/transactions/cash-collection/list/create',
  CASH_COLLECTION_TRANSACTION = '/transactions/cash-collection/list/:transactionId',
  CASH_COLLECTION_ORDERS = '/transactions/cash-collection/orders',
  CASH_COLLECTION_ORDER = '/transactions/cash-collection/orders/:transactionId',
  CASH_COLLECTION_BENEFICIARY_ORDER = '/transactions/cash-collection/orders/beneficiary/:orderId',
  RESTATEMENT_TRANSACTIONS = '/transactions/restatement-transactions',
  RESTATEMENT_TRANSACTION = '/transactions/restatement-transactions/:transactionId',
  TRANSACTIONS_NOTIFICATIONS_CENTER = '/transactions/notification-center',
  EXCHANGE_WITHOUT_CORRECTIONS = '/transactions/exchange-without-corrections',
  EXCHANGE_WITHOUT_CORRECTIONS_ITEM = '/transactions/exchange-without-corrections/:transactionId',
}

export default ROUTES;
